import { createAction, props } from '@ngrx/store';

export const loadTaetCacheStart = createAction('ZEIT::LOAD_TAETCACHE_START', props<{ prjId: number, eingabe: string }>());
export const loadTaetCacheSucceeded = createAction('ZEIT::LOAD_TAETCACHE_SUCCEEDED', props<{ item: string[] }>());
export const loadTaetCacheFailed = createAction('ZEIT::LOAD_TAETCACHE_FAILED', props<{ error: Error }>());
